<div *mwcModalTitle class="mwc-text-lg-semibold mwc-color-gray-900">Select Prompts</div>

<div class="prompts-modal-body">
  <!-- Dynamic alert banner -->
  <mwc-alert
    [mwcType]="alertType"
    [mwcMessage]="alertMsgTemplate"
    [mwcIcon]="alertIconTemplate"
    mwcShowIcon="true"
    class="prompts-alert">
  </mwc-alert>

  <ng-template #alertIconTemplate>
    <span mwc-icon
          [mwcIconfont]="selectedCount >= maxPromptsAllowed ? 'check-circle' : 'stars-02'"
          style="font-size: 16px;">
    </span>
  </ng-template>

  <ng-template #alertMsgTemplate>
    <span *ngIf="selectedCount >= maxPromptsAllowed" class="mwc-text-sm-medium">
      Perfect! You've selected all {{ maxPromptsAllowed }} prompts.
    </span>
    <span *ngIf="selectedCount === 0" class="mwc-text-sm-regular">
      Select <strong>{{ maxPromptsAllowed }} prompts</strong> for best results
    </span>
    <span *ngIf="selectedCount > 0 && selectedCount < maxPromptsAllowed" class="mwc-text-sm-regular">
      Select <strong>{{ remainingCount }} more prompt{{ remainingCount > 1 ? 's' : '' }}</strong> for best results
    </span>
  </ng-template>

  <!-- Prompts list -->
  <div class="prompts-list">
    <div *ngFor="let prompt of prompts"
         class="prompt-item"
         [class.prompt-item--selected]="prompt.selected"
         [class.prompt-item--disabled]="isDisabled(prompt)">
      <label mwc-checkbox
             [mwcChecked]="prompt.selected"
             [mwcDisabled]="isDisabled(prompt)"
             (mwcCheckedChange)="togglePrompt(prompt, $event)">
        <span class="mwc-text-sm-regular mwc-color-gray-700 prompt-text">{{ prompt.text }}</span>
      </label>
    </div>
  </div>
</div>

<div *mwcModalFooter>
  <button mwc-button mwcType="default" (click)="cancel()">Cancel</button>
  <button mwc-button mwcType="primary" [disabled]="selectedCount === 0" (click)="save()">Save</button>
</div>
